import React from "react";
import { ScreenFrame } from "components/onboarding/ScreenFrame";

const MonitoringSkip = ({ history }) => {
  const handleButtonClick = () => {
    history.push("/admin/monitoring");
  };

  return (
    <ScreenFrame
      body={[
        "Para ter acesso à plataforma com todas funcionalidades, é importante que você preencha esses dados!",
      ]}
      buttonText="Conhecer o app da Enermatch"
      title="Atenção!"
      variant="info"
      onClick={handleButtonClick}
      link="/onboarding/monitoring"
      anchorText="Inserir seus dados de acesso"
    />
  );
};

export default MonitoringSkip;
